module.exports = __webpack_public_path__ + "static/media/3_r_arbuzi_80_78.33.a7c9d872.png";